import React, {memo, useMemo} from 'react';
import style from './style.module.scss';
import {TRUST_SLIDER_DATA} from 'modules/slider/constants';
import {adaptive} from 'styles/mixins/Adaptive';
import {useIsWorker} from 'core/hooks/useIsWorker';
import {useIsPrive} from 'core/hooks/useIsPrive';
import cs from 'classnames';
import {Box} from 'components/Grid';
import {TrustSliderItem} from 'modules/slider/components/TrustSlider/TrustSliderItem';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import {useSliderBannerViewTracking} from 'hooks/analytics/gtag/sliders/useSliderBannerViewTracking';
import {SliderItemInView} from 'hooks/analytics/gtag/sliders/useSliderItemInView';
import {SwiperOptions} from 'swiper/types';

const BREAKPOINTS: SwiperOptions['breakpoints'] = {
    [0]: {
        spaceBetween: 8,
    },
    [adaptive.SIZE_SM_MAX]: {
        spaceBetween: 12,
    },
};

const SWIPER_MODULES = [Pagination];
const SWIPER_PAGINATION = {
    clickable: true,
};

interface ITrustSliderProps {
    className?: string;
    gtagEventsEnabled?: boolean;
}

export const TrustSlider = memo(function TrustSlider({className, gtagEventsEnabled = false}: ITrustSliderProps) {
    const isWorker = useIsWorker();
    const isPrive = useIsPrive();

    const slidesList = useMemo(
        () =>
            TRUST_SLIDER_DATA.filter(({notForWorkers, notForPrive}) => {
                return !((isWorker && notForWorkers) || (isPrive && notForPrive));
            }),
        [isWorker, isPrive],
    );

    const {handleItemView} = useSliderBannerViewTracking({
        enabled: gtagEventsEnabled,
        list: slidesList,
        getId: (item) => item.id,
        getName: (item) => item.title,
        type: 'common',
        creative: 'promo_page_trust',
    });

    return (
        <div className={cs(style.main, className)}>
            <Box commonPaddingOnMobileTablet={true}>
                <Swiper
                    breakpoints={BREAKPOINTS}
                    className={style.slider}
                    modules={SWIPER_MODULES}
                    pagination={SWIPER_PAGINATION}
                    slidesPerView={'auto'}
                >
                    {slidesList.map((item, index) => {
                        return (
                            <SwiperSlide className={style.slide} key={item.id}>
                                <SliderItemInView id={item.id} index={index + 1} onView={handleItemView}>
                                    <TrustSliderItem
                                        {...item}
                                        position={index + 1}
                                        gtagEventsEnabled={gtagEventsEnabled}
                                    />
                                </SliderItemInView>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </Box>
        </div>
    );
});
